"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSelectField = void 0;
var core_1 = require("@blueprintjs/core");
var select_1 = require("@blueprintjs/select");
require("@blueprintjs/select/lib/css/blueprint-select.css");
var formstate_1 = require("formstate");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var Spinner_1 = require("../../Spinner");
var Validators_1 = require("../Validators");
var FormFieldContainer_1 = require("./FormFieldContainer");
var style_1 = require("./style");
var ItemSelect = select_1.Select.ofType();
var filterItem = function (query, item) {
    return (!query ||
        "".concat(item.label).toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
        (item && item.label === 'No Selection' && item.value === ''));
};
var VSelectField = (function (_super) {
    __extends(VSelectField, _super);
    function VSelectField(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (ref) {
            _this.ref = ref;
        };
        _this.renderItem = function (item, _a) {
            var _b, _c, _d, _e;
            var handleClick = _a.handleClick, modifiers = _a.modifiers;
            if (!modifiers.matchesPredicate) {
                return null;
            }
            var prevActive = (_this.props.fieldState && item.value === _this.props.fieldState.value) ||
                item.value === _this.props.value;
            var itemIsTheActiveByKeyBoard = ((_b = _this.activeItem) === null || _b === void 0 ? void 0 : _b.value) && item.value === ((_d = (_c = _this.activeItem) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.value);
            var notIncludeSearch = !!_this.state.query &&
                !_this.props.options.find(function (item) {
                    return item.label === _this.state.query || item.label === _this.state.query;
                });
            var active = notIncludeSearch
                ? false
                : (!((_e = _this.activeItem) === null || _e === void 0 ? void 0 : _e.value) && prevActive) || !!itemIsTheActiveByKeyBoard;
            return (react_1.default.createElement(core_1.MenuItem, { active: active, disabled: modifiers.disabled, label: item.rep, key: (0, lodash_1.uniqueId)(), onClick: handleClick, title: item.label, text: item.label, labelElement: _this.props.allowEmptyItem &&
                    item.value === '' &&
                    item.label === 'No Selection' ? (react_1.default.createElement(core_1.Icon, { color: (active && 'white') || '#7486949c', icon: 'reset' })) : null }));
        };
        _this.renderMenu = function (_a) {
            var _b, _c;
            var items = _a.items, itemsParentRef = _a.itemsParentRef, query = _a.query, renderItem = _a.renderItem;
            var renderedItems = items.map(renderItem).filter(function (item) { return item != null; });
            var hasValue = !!(_this.props.value || ((_c = (_b = _this.props) === null || _b === void 0 ? void 0 : _b.fieldState) === null || _c === void 0 ? void 0 : _c.value));
            var itemsToRender = _this.props.allowEmptyItem && renderedItems.length > 0 && hasValue ? (react_1.default.createElement(react_1.default.Fragment, null, renderedItems.map(function (item, index) {
                if (index === 0) {
                    return (react_1.default.createElement(react_1.default.Fragment, { key: "item_".concat(index) },
                        item,
                        react_1.default.createElement(core_1.MenuDivider, { className: 'dividerNoMargin' })));
                }
                return react_1.default.createElement(react_1.default.Fragment, { key: index }, item);
            }))) : (renderedItems);
            var hasQueryValues = !!(_this.state && _this.state.query !== '');
            var notIncludeSearch = !!hasQueryValues &&
                !_this.props.options.find(function (item) {
                    return item.label === _this.state.query || item.label === _this.state.query;
                });
            var createItemView = _this.props.createNewItemFormQuery &&
                notIncludeSearch && (react_1.default.createElement(core_1.MenuItem, { icon: "add", text: "Create \"".concat(query, "\""), active: true, onClick: function () {
                    _this.onItemSelected({ value: query, label: query });
                }, shouldDismissPopover: false }));
            return (react_1.default.createElement(style_1.StyledMenuNoMarginDivider, { ulRef: itemsParentRef },
                renderedItems.length > 0 ? (itemsToRender) : !notIncludeSearch ? (react_1.default.createElement(core_1.MenuItem, { disabled: true, text: "No results." })) : null,
                createItemView));
        };
        _this.getOptions = function () {
            var _a = _this.props, options = _a.options, allowEmptyItem = _a.allowEmptyItem;
            var newOptions = (options &&
                options.length > 0 &&
                (_this.props.allowOrder
                    ? (0, lodash_1.orderBy)(options, ['label'], [_this.props.orderDirection || false])
                    : options)) ||
                [];
            if (allowEmptyItem &&
                options &&
                options.length > 0 &&
                (_this.props.value ||
                    (_this.props.fieldState && _this.props.fieldState.value))) {
                return __spreadArray([{ value: '', label: 'No Selection' }], newOptions, true);
            }
            return newOptions;
        };
        _this.disable = function () {
            return _this.props.isLoading ? true : _this.props.disabled;
        };
        _this.renderRightIcon = function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Icon, { style: {
                        color: _this.props.color && _this.props.color
                    }, icon: _this.props.rightIcon || 'chevron-down' }),
                _this.props.isLoading ? react_1.default.createElement(Spinner_1.VSpinner, { size: 20 }) : undefined));
        };
        _this.renderClearButton = function () { return (react_1.default.createElement(core_1.Button, { style: { width: '30px' }, minimal: true, onClick: _this.onClear, rightIcon: 'filter-remove' })); };
        _this.onClear = function () {
            _this.setState({ query: '' });
        };
        _this.onItemSelected = function (value) {
            if (_this.props.createNewItemFormQuery && value.value !== '') {
                _this.props.createNewItemFormQuery(value);
            }
            setTimeout(function () {
                if (_this.props.fieldState) {
                    _this.props.fieldState.onChange(value.value);
                }
                if (_this.props.onChange) {
                    _this.props.onChange(value.value);
                }
            });
        };
        _this.showClear = false;
        _this.selectedItem = new formstate_1.FieldState(null);
        _this.activeItem = new formstate_1.FieldState(null);
        _this.changed = new formstate_1.FieldState(false);
        _this.state = {
            query: ''
        };
        _this.ref = react_1.default.createRef();
        return _this;
    }
    VSelectField.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, label = _b.label, labelInfo = _b.labelInfo, fieldState = _b.fieldState, disabled = _b.disabled, inline = _b.inline, id = _b.id, options = _b.options, icon = _b.icon, filterable = _b.filterable, className = _b.className, layer = _b.layer, fill = _b.fill, noLabel = _b.noLabel, required = _b.required, validators = _b.validators, fixedInputWidthPx = _b.fixedInputWidthPx, iconOnly = _b.iconOnly, minimal = _b.minimal, margin = _b.margin, tipLabel = _b.tipLabel, popoverProps = _b.popoverProps, tooltip = _b.tooltip, displayRequired = _b.displayRequired, upperCaseFormatFilter = _b.upperCaseFormatFilter;
        var initialContent = options && options.length === 0 ? (react_1.default.createElement(core_1.MenuItem, { className: className, disabled: true, text: "".concat(options.length, " items loaded.") })) : (undefined);
        if (fieldState) {
            if (required) {
                if (validators && validators.length > 0) {
                    fieldState.validators.apply(fieldState, __spreadArray([Validators_1.Validators.required], validators, false));
                }
                else {
                    fieldState.validators(Validators_1.Validators.required);
                }
            }
            else if (validators && validators.length > 0) {
                fieldState.validators.apply(fieldState, validators);
            }
        }
        var areItemsEqual = function (itemA, itemB) {
            return itemA.value === itemB.value;
        };
        var onActiveItemChange = function (item) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var isOutEmptyOption = _this.getOptions().some(function (item) { return !!(item.value === '' && item.label === 'No Selection'); });
            if ((_this.props.allowEmptyItem && isOutEmptyOption) ||
                _this.props.allowOrder) {
                if (!((_a = _this.changed) === null || _a === void 0 ? void 0 : _a.value)) {
                    if ((_b = _this.selectedItem) === null || _b === void 0 ? void 0 : _b.value) {
                        if (_this.state) {
                            if (((_d = (_c = _this.activeItem) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.value) !== (item === null || item === void 0 ? void 0 : item.value)) {
                                _this.activeItem.onChange(((_e = _this.selectedItem) === null || _e === void 0 ? void 0 : _e.value) || null);
                            }
                        }
                        _this.selectedItem.onChange(null);
                    }
                    else {
                        if (((_g = (_f = _this.activeItem) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.value) !== (item === null || item === void 0 ? void 0 : item.value)) {
                            _this.activeItem.onChange(item);
                        }
                    }
                    _this.changed.onChange(true);
                }
                else {
                    _this.changed.onChange(false);
                }
            }
            else {
                _this.activeItem &&
                    ((_h = _this.activeItem.value) === null || _h === void 0 ? void 0 : _h.value) !== (item === null || item === void 0 ? void 0 : item.value) &&
                    _this.activeItem.onChange(item);
            }
        };
        var onOpening = function () {
            var _a, _b;
            var value = ((_a = _this.props.fieldState) === null || _a === void 0 ? void 0 : _a.value) || _this.props.value;
            if ((_b = _this.ref) === null || _b === void 0 ? void 0 : _b.hasOwnProperty('previousFocusedElement')) {
                _this.ref.previousFocusedElement = undefined;
            }
            if (value) {
                var newActiveItem = _this.getOptions() &&
                    _this.getOptions().length > 0 &&
                    _this.getOptions().find(function (el) { return el.value === value; });
                if (newActiveItem) {
                    _this.activeItem.onChange(newActiveItem);
                    _this.changed.onChange(true);
                    return;
                }
            }
            _this.activeItem.onChange(null);
            _this.changed.onChange(true);
        };
        return (react_1.default.createElement(style_1.StyledPopOverWrapper, { disabled: this.disable(), inline: inline, intent: fieldState && fieldState.hasError ? core_1.Intent.DANGER : core_1.Intent.NONE, labelFor: id, labelInfo: labelInfo, layer: layer, fill: fill, noLabel: noLabel, fixedInputWidthPx: fixedInputWidthPx, margin: margin },
            react_1.default.createElement(FormFieldContainer_1.FormFieldContainer, { required: required || displayRequired, noLabel: noLabel, label: label, fieldState: fieldState, tooltip: tooltip },
                tipLabel && react_1.default.createElement("span", { className: 'tipLabel' }, tipLabel),
                react_1.default.createElement(ItemSelect, { ref: this.setRef, activeItem: (_a = this.activeItem) === null || _a === void 0 ? void 0 : _a.value, onActiveItemChange: onActiveItemChange, resetOnSelect: true, itemPredicate: filterItem, itemRenderer: this.renderItem, items: this.getOptions(), disabled: this.disable(), itemListRenderer: this.renderMenu, initialContent: initialContent, onItemSelect: this.onItemSelected, itemsEqual: areItemsEqual, filterable: filterable, popoverProps: __assign({ onOpening: onOpening, modifiers: {
                            flip: { enabled: true },
                            keepTogether: { enabled: true },
                            preventOverflow: { enabled: true }
                        }, shouldReturnFocusOnClose: false, captureDismiss: true }, popoverProps), resetOnClose: this.props.resetOnClose, className: this.props.isLoading ? core_1.Classes.SKELETON : '', onQueryChange: function (value) { return _this.setState({ query: value }); }, query: upperCaseFormatFilter
                        ? ((this.state && this.state.query) || '').toUpperCase()
                        : (this.state && this.state.query) || '', inputProps: {
                        rightElement: this.renderClearButton()
                    } }, iconOnly ? (react_1.default.createElement(core_1.ButtonGroup, null,
                    react_1.default.createElement(core_1.Button, __assign({ className: minimal ? 'bp3-minimal' : '', style: {
                            justifyContent: 'center',
                            color: this.props.color && this.props.color
                        } }, {
                        icon: icon,
                        disabled: disabled
                    }, { text: iconOnly && undefined })))) : (react_1.default.createElement(core_1.Button, __assign({ onMouseEnter: function () {
                        _this.showClear = true;
                    }, onMouseLeave: function () {
                        _this.showClear = false;
                    }, className: minimal ? 'bp3-minimal' : '' }, {
                    icon: icon,
                    disabled: disabled
                }, { rightIcon: this.renderRightIcon(), disabled: this.disable(), text: this.fieldText, style: {
                        color: this.props.color && this.props.color
                    } })))))));
    };
    Object.defineProperty(VSelectField.prototype, "fieldText", {
        get: function () {
            var fValue = '';
            if (this.props.fieldState) {
                fValue = this.props.fieldState.value;
            }
            else if (this.props.value !== undefined && this.props.value !== null) {
                fValue = this.props.value;
            }
            if (fValue !== undefined && fValue !== null) {
                var item = this.props.options.find(function (value) {
                    return fValue === value.value;
                });
                if (item) {
                    return item.label;
                }
            }
            return this.props.defaultText || 'No selection';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], VSelectField.prototype, "showClear", void 0);
    __decorate([
        mobx_1.observable
    ], VSelectField.prototype, "selectedItem", void 0);
    __decorate([
        mobx_1.observable
    ], VSelectField.prototype, "changed", void 0);
    __decorate([
        mobx_1.observable
    ], VSelectField.prototype, "activeItem", void 0);
    __decorate([
        mobx_1.observable
    ], VSelectField.prototype, "ref", void 0);
    __decorate([
        mobx_1.action
    ], VSelectField.prototype, "setRef", void 0);
    __decorate([
        mobx_1.computed
    ], VSelectField.prototype, "fieldText", null);
    VSelectField = __decorate([
        mobx_react_1.observer
    ], VSelectField);
    return VSelectField;
}(react_1.default.Component));
exports.VSelectField = VSelectField;
